import { FunctionComponent, ChangeEvent } from "react"

type LoginInputType = {
  id?: string
  inputTitleText: string
  inputPlaceholderText: string
  inputType?: string
  required?: boolean
  disabled?: boolean
  defaultValue?: string
  error?: string
  setValue?: (value: string) => void
}

const LoginInput: FunctionComponent<LoginInputType> = ({
  id,
  inputTitleText,
  inputPlaceholderText,
  inputType = "text",
  required,
  disabled = false,
  error,
  defaultValue,
  setValue,
}) => {
  const thisId = id ?? Math.random().toString(36).substring(2, 15)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    if (setValue) {
      setValue(value)
    }
  }

  return (
    <div className="relative w-full flex flex-col items-start justify-start gap-[6px] text-left text-sm text-gray-700 font-text-md-regular1">
      <div className="self-stretch flex flex-col items-start justify-start gap-[6px]">
        {inputTitleText && (
          <div className="relative leading-[24px] font-medium">
            <label htmlFor={thisId}>{inputTitleText}</label>
          </div>
        )}
        <input
          id={thisId}
          className={`self-stretch rounded-lg bg-base-white shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row py-2.5 px-3.5 items-center justify-start gap-[8px] text-base text-gray-500 border-[1px] border-solid ${
            error ? "border-red-300" : "border-gray-300"
          }`}
          placeholder={inputPlaceholderText}
          type={inputType}
          required={required}
          disabled={disabled}
          value={defaultValue}
          onChange={handleChange}
        />
        {error && <div className="text-red-500 text-sm">{error}</div>}
      </div>
    </div>
  )
}

export default LoginInput
